import authInstance from "../Interceptor";

export const AddWholesalerEffect = (data, config) => {
  return authInstance.post("/wholesalers/insertwholesaler", data, config);
};

export const EditWholesalerEffect = (wholesalerId, updatedData) => {
  return authInstance.put(
    `/wholesalers/updatewholesaler/${wholesalerId}`,
    updatedData
  );
};

export const DeleteWholesalerEffect = (wholesalerId) => {
  return authInstance.delete(`/wholesalers/delete/${wholesalerId}`);
};

export const ViewWholesalerEffect = (wholesalerId) => {
  return authInstance.get(
    `/wholesalers/getwholesaler?wholesaler_id=${wholesalerId}`
  );
};

export const ViewAllWholesalersEffect = (payload) => {
  return authInstance.get(
    `/wholesalers/list?pagination_required=true&pagesize=10&pageNo=${payload.pageNo}&search_key=${payload.search_key}`
  );
};

export const ViewAllSearchWholesalersEffect = () => {
  return authInstance.get(`/wholesalers/list`);
};
